import { Component } from '@angular/core';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';

import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import { Subscription } from 'rxjs';

//SERVICE
import { ForAllService } from "../services/forall.service";
//SERVICE
import { TranslateServiceApi } from "../services/translate.service";
import { BroadcastService } from '../broadcast.service';
import { BroadcastTranslateService } from '../broadcasttranslate.service';

import { PreviewService } from "../services/preview.service";

///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_idiomas } from 'app/idiomas/i18n/idiomas/idiomas.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';


@Component({
    selector     : 'preview',
    templateUrl  : './preview.component.html',
    styleUrls    : ['./preview.component.scss'],
    animations   : fuseAnimations
})
export class PreviewComponent {

  subscription: Subscription;
  subscriptiontranslate: Subscription;

  nombreEmpresa:string;
  idiomasArray: any;
  nombreIdioma: string = 'en';
  questions = [];


  constructor(public forallService: ForAllService,
              public translateService: TranslateServiceApi,
              public previewService: PreviewService,
              public _fuseTranslationLoaderService: FuseTranslationLoaderService,
              public broadcast: BroadcastService,
              public broadcasttranslate: BroadcastTranslateService) {
                lang_idiomas.forEach((locale) => {
                  this._fuseTranslationLoaderService.loadTranslations(locale);
                });


    lang_certificar.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    // subscribe to product component
   this.subscription = this.broadcast.getEvent().subscribe(product => {
      this.getLanguajesList();

    });

    // subscribe to product component
   this.subscriptiontranslate = this.broadcasttranslate.getEvent().subscribe(product => {
      this.getLanguajesList();

    });

  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.questions, event.previousIndex, event.currentIndex);
    this.updateOrder();
  }

  onDrop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
  }

  public updateOrder(){
    let count = 0;
      for (let item of this.questions){

        count = count+1;
        this.requestUpdate(localStorage.getItem('fechaProducto'),item['_id'],count);
      }
  }

  public requestUpdate(fecha,idPractice,orden){
      let data = {"fechaCertificar": fecha,
                    "idForall": idPractice,
                    orden: orden
                  };

      this.forallService.updateOrderForall(data)
        .subscribe(response => {

         console.log(response);

        }, error => {
          console.log("error", error);
        })

  }

  public getLanguajesList(){
    let data = {
      fechaCertificar:localStorage.getItem('fechaProducto')
    };
      this.translateService.getLanguajesListNon3(data)
      .subscribe(response => {
        let res = [];
        this.idiomasArray = response['idiomasMostrar'];


      }, error => {
        console.log("error", error);
      })

  }

  public changeIdioma(event){
    this.nombreIdioma = event.value.nombreIdioma;
    if(event.value.tipoIdioma == 1){
      this.getNative();
    }else{
      this.getStamentsData(event.value.nombreIdioma,event.value._id);
    }

  }

  public getStamentsData(clave,id){
    let data = {"clave": clave,
                "fechaCertificar": localStorage.getItem('fechaProducto'),
                "idiomaId": id};

    this.forallService.getTest(data)
    .subscribe(response => {
      console.log(response);
      let res = [];

          for (let i = 0; i < response['objeto']['idForall'].length; i++) {

            this.nombreEmpresa = response['empresa'];

            var splitted1 = response['objeto']['statement1'].split("$replace1");
            var splitted2 = response['objeto']['statement2'].split("$replace1");

            var statement1Part1 = splitted1[0];
            var statement1Part2 = splitted1[1];

            var statement2Part1 = splitted2[0];
            var statement2Part2 = splitted2[1].replace("$replace2","");


              res.push(
                  {
                    orden: i,
                    practicaForall: response['objeto']['idForall'][i]['practicaForall'],
                    statement1: response['objeto']['statement1'].replace('$replace1',response['objeto']['idForall'][i]['practicaForall']),
                    statement2: response['objeto']['statement2'].replace('$replace1',response['objeto']['idForall'][i]['practicaForall']).replace('$replace2',response['empresa']),
                    _id: response['objeto']['idForall'][i]['idForall'],
                    statement1Part1: statement1Part1,
                    statement1Part2: statement1Part2,
                    statement2Part1: statement2Part1,
                    statement2Part2: statement2Part2,
                    description: response['objeto']['idForall'][i]['descripcionForall']
                  });
              }
          this.questions = res;
          console.log(this.questions);

    }, error => {
      console.log("error", error);
    });
  }



  public getNative(){
  let data = {"fechaCertificar": localStorage.getItem('fechaProducto')};

    this.forallService.getParams(data)
    .subscribe(response => {

      this.nombreEmpresa = response['empresa'];
      var nombreEmpresa = response['empresa'];

      var splitted1 = response['objeto']['statement1Nativo'].split("$replace1");
      var splitted2 = response['objeto']['statement2Nativo'].split("$replace1");

      var statement1Part1 = splitted1[0];
      var statement1Part2 = splitted1[1];
      var statement2Part1 = splitted2[0];
      var statement2Part2 = splitted2[1].replace("$replace2","");

      this.forallService.getPracticesSaved(data)
        .subscribe(response2 => {

          let res = [];

          for (let i = 0; i < response2['practicas'].length; i++) {

              res.push(
                  {
                    orden: i,
                    practicaForall: response2['practicas'][i]['practicaForall'],
                    statement1: '',
                    statement2: '',
                    _id: response2['practicas'][i]['_id'],
                    statement1Part1: statement1Part1,
                    statement1Part2: statement1Part2,
                    statement2Part1: statement2Part1,
                    statement2Part2: statement2Part2,
                    description: response2['practicas'][i]['descripcionForall']
                  });
              }
              this.questions = res;
      }, error => {
        console.log("error", error);
      })

    }, error => {
      console.log("error", error);
    });
  }

  }
